import { USER } from '@/api'

export default {
  viewType: 'table',
  module: USER,
  toolbar: {
    searchPlaceholder: 'name',
    searchFieldNameArr: ['realName'],
    items: [
      {
        slot: 'refresh-rigtht',
        label: '同步飞书用户',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'SyncFeiShuUser'
      },
      {
        slot: 'refresh-rigtht',
        label: '手动添加用户',
        props: {
          type: 'success',
          icon: 'el-icon-plus'
        },
        action: 'AddHandelFeiShuUser'
      }
    ]
  },
  view: {
    columns: [
      {
        props: {
          type: 'selection',
          width: 55
        }
      },
      {
        props: {
          label: 'name',
          prop: 'realName'
        }
      },
      {
        props: {
          label: 'form.common_email',
          prop: 'email'
        }
      }
    ]
  }
}
